import {Deserializable} from '../deserializable';
import {DonViNgoai} from '../danhmuc/donvingoai';
import {DoKhan} from '../danhmuc/dokhan';
import {KeHoachFile} from '../kehoach/kehoachfile';
import {VanBanDenFile} from './vanbandenfile';
import {Staffs} from '../staff/staffs';
import {DoMat} from '../danhmuc/domat';



export  class VanBanDen implements Deserializable
{
  public  id: number;
  public  soVaoSo: string;
  public  soHieuGoc: string;
  public  trichYeu: string;
  public  maLoaiVB: number;
  public  maLinhVuc: number;
  public  maDoMat: number;
  public  maDoKhan: number;
  public  maNoiGui: number;
  public  noiPhatHanh:  DonViNgoai;
  public  ngayKy: string;
  public  nguoiKy: string;
  public  ngayNhan: string;
  public  nguoiNhan: string;
  public  ngayVaoSo: string;
  public  thoiHan: string;
  public  maNguoiChuTri: number;
  public  noiDungXL: string;
  public  ghiChu: string;
  public  maTrangThaiXL: number;
  public  phoCap: number;
  public  maNguoiDG: number;
  public  xepLoaiDG: number;
  public  suDung: number;
  public  thongTinKhac: string;
  public  choXem: number;
  public  noiLuu: string;
  public  usersRead: string;
  public  soLuotDoc: number;
  public  nguoiNhapID: number;
  public  soVanThuID: number;
  public  logVanBan: string;
  public  userDuocXemIDs: string;
  public  doKhan: DoKhan;
  public  doMat: DoMat;
  public  vanBanDenFiles: VanBanDenFile[];
  public nguoiChuTri: Staffs;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.noiPhatHanh = input.noiPhatHanh!= null ? new DonViNgoai().deserialize(input.noiPhatHanh): null;
    this.doKhan = input.doKhan!= null ? new DoKhan().deserialize(input.doKhan): null;
    this.doMat = input.doMat!= null ? new DoMat().deserialize(input.doMat): null;
    this.nguoiChuTri = input.nguoiChuTri!= null ? new Staffs().deserialize(input.nguoiChuTri): null;
    this.vanBanDenFiles = input.vanBanDenFiles != null ? input.vanBanDenFiles.map(vanBanDenFiles => new VanBanDenFile().deserialize(vanBanDenFiles)): [];
    return this;
  }
}
